import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const equipmentRepository = RepositoryFactory.get("equipment");

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setEquipment(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadEquipment(context) {
    const equipments = await equipmentRepository.list();
    if (equipments.status < 300) {
      context.commit("setEquipment", equipments.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
